import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "1. Verantwortliche Stelle",
    body: (
      <>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        <br />
        <br />
        Wagenhofer Capital GmbH
        <br />
        Max-Löw-Straße 27
        <br />
        85579 Neubiberg
        <br />
        Deutschland
        <br />
        E-Mail: muenchen@wagenhofer.capital
      </>
    ),
  },
  {
    title: "2. Erhebung und Speicherung personenbezogener Daten",
    body: (
      <>
        Wir verarbeiten personenbezogene Daten ausschließlich im gesetzlich
        zulässigen Rahmen. Die Erhebung erfolgt entweder durch aktive
        Mitteilung (z. B. über das Kontaktformular) oder automatisiert beim
        Besuch der Website.
      </>
    ),
  },
  {
    title: "3. Kontaktformular",
    body: (
      <>
        Bei der Nutzung des Kontaktformulars werden die im Formular eingegebenen
        Daten (Name, Unternehmen, E-Mail, Nachricht) zur Bearbeitung
        Ihrer Anfrage erhoben. Die Verarbeitung erfolgt auf Grundlage von Art. 6
        Abs. 1 lit. b und f DSGVO. Die Daten werden nach Erledigung Ihrer
        Anfrage gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
        bestehen.
      </>
    ),
  },
  {
    title: "4. Server-Log-Dateien",
    body: (
      <>
        Der Provider erhebt und speichert automatisch Informationen in
        sogenannten Server-Log-Dateien, die Ihr Browser übermittelt
        (Browsertyp, Betriebssystem, Referrer-URL, IP-Adresse, Uhrzeit). Diese
        Daten sind nicht bestimmten Personen zuordenbar und dienen
        ausschließlich der technischen Sicherstellung des Betriebs.
      </>
    ),
  },
  {
    title: "5. Cookies",
    body: (
      <>
        Diese Website verwendet ausschließlich technisch notwendige Cookies, um
        ihre Funktionalität sicherzustellen. Es werden keine Tracking- oder
        Werbe-Cookies eingesetzt, sofern Sie nicht ausdrücklich zugestimmt
        haben.
      </>
    ),
  },
  {
    title: "6. Rechte der betroffenen Personen",
    body: (
      <>
        Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung,
        Einschränkung der Verarbeitung, Widerspruch sowie Datenübertragbarkeit
        gemäß DSGVO. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen
        Aufsichtsbehörde zu.
      </>
    ),
  },
  {
    title: "7. Kontakt für Datenschutzanfragen",
    body: (
      <>
        Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie
        sich bitte an: muenchen@wagenhofer.capital
      </>
    ),
  },
];

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutz | Wagenhofer Capital";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black text-white min-h-screen">
      <Navigation />

      <section className="pt-40 pb-24 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="datenschutz-back"
            className="inline-flex items-center gap-2 text-xs tracking-[0.28em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors mb-12"
          >
            <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
            Zurück
          </Link>
          <div className="overline mb-6">Rechtliches</div>
          <h1
            data-testid="datenschutz-headline"
            className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tighter font-medium leading-[1.02] mb-10"
          >
            Datenschutzerklärung
          </h1>
          <span className="block w-12 h-px bg-[#D4AF37]" />
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-12 text-zinc-300 leading-relaxed font-light">
          {sections.map((section, idx) => (
            <div key={idx} data-testid={`datenschutz-section-${idx + 1}`}>
              <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
                {section.title}
              </h2>
              <p>{section.body}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
